export default __webpack_public_path__ + "static/media/Schneider-legrand1mob.5c4ea9b5.png";